import { call } from 'redux-saga/effects';
import { signalingContentWhiteboardDataReceived } from 'features/content-whiteboard/actions';
import { initContentWhiteboardDataSaga } from 'features/content-whiteboard/sagas/initContentWhiteboardDataSaga';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';

export function* onContentWhiteboardDataReceivedSaga(
  action: ReturnType<typeof signalingContentWhiteboardDataReceived>
) {
  if (contentBoard.type !== 'file' || contentBoard.id !== action.payload.id) {
    return;
  }

  yield call(initContentWhiteboardDataSaga, action.payload);
}
